import { render, staticRenderFns } from "./opened-tickets.vue?vue&type=template&id=5b2e2c30&"
import script from "./opened-tickets.vue?vue&type=script&lang=js&"
export * from "./opened-tickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports